import { render, staticRenderFns } from "./CourseArea.vue?vue&type=template&id=606aa459&scoped=true&"
import script from "./CourseArea.vue?vue&type=script&lang=js&"
export * from "./CourseArea.vue?vue&type=script&lang=js&"
import style0 from "./CourseArea.vue?vue&type=style&index=0&id=606aa459&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606aa459",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
